import * as React from 'react';
import { TextFieldProps as MuiTextFieldProps, TextField as MuiTextField, makeStyles, createStyles } from '@material-ui/core';

import cn from 'classnames';
import { TranquiTheme } from '../../containers/App/theme';

export type TextFieldProps = MuiTextFieldProps & {
  disableAutoComplete?: boolean;
  disabled?:boolean;
  endAdornment?: any;
};

const TextField: React.FC<TextFieldProps> = (
  { variant = 'outlined', autoComplete, disableAutoComplete, disabled = false, endAdornment, ...props },
) => {
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const classes = useStyles();
  const out = variant === 'outlined';
  const stand = variant === 'standard';

  return (
    <MuiTextField
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      InputLabelProps={{
        ...props.InputLabelProps,
        classes: {
          ...props.InputLabelProps?.classes,
          formControl: cn(out && classes.label),
        },
      }}
      InputProps={{
        ...props.InputProps,
        classes: {
          ...props.InputProps?.classes,
          root: cn(out && classes.root, stand && classes.standard),
          input: cn(out && classes.input),
          notchedOutline: cn(
            out && !props.label && classes.withoutLabel, disabled && classes.inputTextField,
          ),

        },
        autoComplete: disableAutoComplete ? 'off' : autoComplete,
        disabled,
        endAdornment,
      }}
      variant={variant as any}
    />
  );
};

const useStyles = makeStyles((theme: TranquiTheme) => createStyles({
  label: {
    position: 'unset',
    transform: 'unset !important',
    marginBottom: '0.5em',
    ...theme.typography.body2,
    color: theme.palette.text3.main,
    '&[data-shrink="false"] + .MuiInputBase-formControl .MuiInputBase-input::placeholder': {
      opacity: '0.42 !important',
      transition: 'none !important',
    },
  },
  root: {
    '& legend span': {
      display: 'none',
    },
    '& .MuiFormLabel-root': {
      ...theme.typography.body2,
      '&.Mui-focused': {
        color: theme.palette.black.main,
      },
    },
  },
  input: {
    padding: '0.8em 1em',
    '&.Mui-focused': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.secondary.main,
        borderWidth: '1px',
      },
    },
    '&.Mui-disabled': {
      '& .MuiOutlinedInput-notchedOutline': {
        color: theme.palette.text6.main,
      },
    },
  },
  withoutLabel: {
    top: 0,
  },
  standard: {
    ...theme.typography.h3,
    color: theme.palette.black.main,
    '& .MuiInputBase-input:focus': {
    },
    '&::after': {
      borderBottom: `solid 2px ${theme.palette.secondary.main}`,
      borderWidth: '1px',
    },
  },
  '.MuiFormLabel-root.Mui-focused': {
    color: theme.palette.black.main,
  },
  inputTextField: {
    borderColor: `${theme.palette.text6.main}50 !important`,
  },
}));

export default TextField;
